<template>
  <div
    class="md:flex lg:flex xl:flex min-h-screen-1/2 overflow-y-auto bg-gray-200 detail-container z-40"
  >
    <div class="w-full md:w-2/3 lg:w-2/3 xl:w-2/3 bg-white h-auto py-3">
      <dpa-connect-event v-if="event" :event="event" />
      <dpa-connect-news-item
        v-if="newsItem"
        :news-item="newsItem"
        :image-thumbnail="imageThumbnail"
      />
    </div>
    <div
      class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 h-auto py-3 mr-12 ml-3 md:ml-6 lg:ml-6 xl:ml-6"
    >
      <div class="md:fixed md:mt-12 lg:fixed lg:mt-12 xl:fixed xl:mt-12">
        <a
          :href="sourceUrl"
          target="_blank"
          v-if="sourceAppName"
          class="justify-center bg-blue hover:bg-blue-dark hover:border-blue-dark text-white flex py-2 px-3 detail-link"
        >
          <ui-select-icon v-if="newsItem" />
          <ui-agenda-icon v-if="event" />
          <span class="flex-initial px-1 self-center"
            >Öffnen in {{ sourceAppName }}</span
          >
        </a>
        <button
          v-if="sourceAppName"
          class="p-1 mt-4 flex items-center h-8 px-2 py-1 transition duration-150 rounded-full hover:bg-gray-300 text-small text-gray-600 hover:text-gray-900"
          :title="
            typeTranslation +
            ' aus Mappe entfernen. Die Aktion kann nicht rückgängig gemacht werden.'
          "
          @click.stop="$emit('delete', { folderItemId })"
        >
          <svg
            class="h-4 mr-1 fill-current"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.11111 1.33333C10.0579 1.33333 10.8318 2.07343 10.8859 3.00665L10.8889 3.11111L10.8888 3.70362L13.2593 3.7037C13.5593 3.7037 13.8072 3.92664 13.8464 4.21588L13.8519 4.29629C13.8519 4.62357 13.5865 4.88888 13.2593 4.88888L12.6659 4.88837L12.6667 12.5926C12.6667 13.5394 11.9266 14.3133 10.9933 14.3673L10.8889 14.3704H4.96296C4.01619 14.3704 3.24228 13.6303 3.1882 12.697L3.18519 12.5926L3.18474 4.88837L2.59259 4.88888C2.29259 4.88888 2.04465 4.66595 2.00541 4.3767L2 4.29629C2 3.96901 2.26531 3.7037 2.59259 3.7037L4.96267 3.70362L4.96296 3.11111C4.96296 2.16433 5.70306 1.39042 6.63628 1.33635L6.74074 1.33333H9.11111ZM11.4812 4.88837H4.3703L4.37037 12.5926C4.37037 12.8965 4.59914 13.147 4.89385 13.1812L4.96296 13.1852H10.8889C11.1928 13.1852 11.4433 12.9564 11.4775 12.6617L11.4815 12.5926L11.4812 4.88837ZM9.11111 6.66666C9.43839 6.66666 9.7037 6.93197 9.7037 7.25925V10.8148C9.7037 11.1421 9.43839 11.4074 9.11111 11.4074C8.78383 11.4074 8.51852 11.1421 8.51852 10.8148V7.25925C8.51852 6.93197 8.78383 6.66666 9.11111 6.66666ZM6.74074 6.66666C7.06802 6.66666 7.33333 6.93197 7.33333 7.25925V10.8148C7.33333 11.1421 7.06802 11.4074 6.74074 11.4074C6.41346 11.4074 6.14815 11.1421 6.14815 10.8148V7.25925C6.14815 6.93197 6.41346 6.66666 6.74074 6.66666ZM9.11111 2.51851H6.74074C6.43684 2.51851 6.18637 2.74728 6.15213 3.042L6.14815 3.11111L6.14741 3.70362H9.70326L9.7037 3.11111C9.7037 2.8072 9.47494 2.55673 9.18022 2.5225L9.11111 2.51851Z"
            />
          </svg>
          {{ typeTranslation }} aus Mappe entfernen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import DpaConnectEvent from "@dpa-connect/dpa-connect-event";
import DpaConnectNewsItem from "@dpa-connect/dpa-connect-news-item";
import UiSelectIcon from "./icons/UiSelectIcon";
import UiAgendaIcon from "./icons/UiAgendaIcon";

export default Vue.extend({
  props: {
    folderItemId: {
      type: String,
      require: true
    },
    id: {
      type: String,
      require: true
    },
    type: {
      type: String
    },
    token: {
      type: String
    },
    event: {
      type: [Object, String],
      required: false
    },
    newsItem: {
      type: [Object, String],
      required: false
    },
    imageThumbnail: {
      type: String,
      required: false
    }
  },
  components: {
    DpaConnectEvent,
    DpaConnectNewsItem,
    UiSelectIcon,
    UiAgendaIcon
  },
  computed: {
    sourceAppName() {
      if (this.event) {
        return "dpa-Agenda";
      }

      if (this.newsItem) {
        return "dpa-Select";
      }

      return "";
    },
    stage() {
      return this.$store.state.stageConfig.stage;
    },
    appURL() {
      return this.$store.state.stageConfig.appURL?.[this.sourceAppName];
    },
    sourceUrl() {
      const appPath = {
        "dpa-Agenda": "/events/standard/detail",
        "dpa-Select": "/newsitems/list"
      };

      return `${this.appURL}/app${appPath[this.sourceAppName]}/${this.id}`;
    },
    typeTranslation() {
      switch (this.type) {
        case "event":
          return "Termin";
        case "topic":
          return "Thema";
        case "text":
          return "Text";
        case "picture":
          return "Foto";
        case "graphic":
          return "Grafik";
        default:
          return "";
      }
    }
  }
});
</script>

<style>
@import "~@dpa-connect/dpa-connect-event/lib/dpa-connect-event.css";
@import "~@dpa-connect/dpa-connect-news-item/lib/dpa-connect-news-item.css";
</style>

<style scoped>
.detail-container {
  max-height: calc(100vh - theme("spacing.12"));
}

@media (max-width: 767px) {
  .detail-container {
    flex-direction: column;
  }

  .detail-link {
    width: fit-content;
  }
}
</style>
